function IndicatorTextStyle(isNegative) {
  return { color: isNegative ? "error" : "black" };
}

export { IndicatorTextStyle };
